import {AbstractControl, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import * as moment from 'moment';
import {GlobalUtil} from '../../services/utils/global.util';

export function requireCheckboxesToBeCheckedValidator(minRequired = 1): ValidatorFn {
    return function validate (formGroup: UntypedFormGroup) {
        let checked = 0;

        Object.keys(formGroup.controls).forEach(key => {
            const control = formGroup.controls[key];

            if (control.value === true) {
                checked ++;
            }
        });

        if (checked < minRequired) {
            return {
                requireOneCheckboxToBeChecked: true,
            };
        }

        return null;
    };
}

export function noWhitespaceValidator(control: UntypedFormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
}

export function checkIfEndDateAfterStartDate (startDateName: string, endDateName: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!!control.validator) {
            const start = control.get(startDateName).value ? control.get(startDateName).value as moment.Moment : null;
            const end = control.get(endDateName).value ? control.get(endDateName).value as moment.Moment : null;

            if (!!start && !!end) {
                const isStartMoment = start instanceof moment.default;
                const isEndMoment = end instanceof moment.default;

                if (isStartMoment && isEndMoment) { // if dates are moment objects and so can be compared
                    if (end.isBefore(start)) {
                        return { 'dateEndIsBefore': true };
                    }
                }
            }
        }

        return null;
    };
}

export function dateFormat(dateFormat: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

        let isRequired = false;
        if (control.hasValidator(Validators.required)) {
            isRequired = true;
        }

        let isValid = true;

        if (!control.value && isRequired === false) {
            return null;
        }

        const isMoment = control.value instanceof moment.default;

        if (isMoment === false) {
            const respectFormat = moment.default(control.value, dateFormat, true).isValid();
            if (respectFormat === false) {
                isValid = false;
            }
        }

        const returnError: ValidationErrors = {'noDateFormat': dateFormat };
        return isValid === false ? returnError : null;
    };
}

export function numberFormat(control: UntypedFormControl) {
    if (!control.value) {
        return null;
    }
    const numberFormat = new RegExp(/^[0-9]{4}$/, 'g');
    const isValid = numberFormat.test(control.value);
    return isValid ? null : { 'wrongNumberFormat': true };
}

export function ValidatePhoneNumber(control: UntypedFormControl) {
    const regex = new RegExp('^(0|\\+33)[6-7]([0-9]{2}){4}$');
    if (control.value && !regex.test(control.value)) {
        return { invalidPhone: true };
    }
    return null;
}

export function ValidateEmail(control: UntypedFormControl) {
    const regex = new RegExp('^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$');
    if (control.value && !regex.test(control.value)) {
        return { invalidPhone: true };
    }
    return null;
}
